export default (accessRoles, ruleConfig, element) => {
    if (!element || !element.VisibilityConditions) {
        return true;
    }

    const getRefConfigValue = (ruleConfig, fieldRefProps) => {
        let refConfigValue = ruleConfig;
        for (const prop of fieldRefProps) {
            if (!refConfigValue) return null;
            refConfigValue = refConfigValue[prop];
        }
        return refConfigValue;
    };

    const visibilityType = element.VisibilityType || "all";
    let visibleCondition = visibilityType === "all";

    for (const condition of element.VisibilityConditions) {
        if (condition.FieldReference && condition.FieldReference.includes(".")) {
            const fieldRefProps = condition.FieldReference.split(".");
            const refConfigValue = getRefConfigValue(ruleConfig, fieldRefProps);
            const leftSide = String(refConfigValue);
            const rightSide = String(condition.FieldValue);
            switch (condition.Operator) {
                case "equal":
                    if (visibilityType === "all") {
                        visibleCondition = visibleCondition && (leftSide === rightSide);
                    } else {
                        visibleCondition = leftSide === rightSide || visibleCondition;
                    }
                    break;
                case "notEqual":
                    if (visibilityType === "all") {
                        visibleCondition = visibleCondition && leftSide !== rightSide;
                    } else {
                        visibleCondition = leftSide !== rightSide || visibleCondition;
                    }
                    break;
                case "greaterThan":
                    if (visibilityType === "all") {
                        visibleCondition = visibleCondition && leftSide > rightSide;
                    } else {
                        visibleCondition = leftSide > rightSide || visibleCondition;
                    }
                    break;
                case "greaterThanOrEqualTo":
                    if (visibilityType === "all") {
                        visibleCondition = visibleCondition && leftSide >= rightSide;
                    } else {
                        visibleCondition = leftSide >= rightSide || visibleCondition;
                    }
                    break;
                case "lessThan":
                    if (visibilityType === "all") {
                        visibleCondition = visibleCondition && leftSide < rightSide;
                    } else {
                        visibleCondition = leftSide < rightSide || visibleCondition;
                    }
                    break;
                case "lessThanOrEqualTo":
                    if (visibilityType === "all") {
                        visibleCondition = visibleCondition && leftSide <= rightSide;
                    } else {
                        visibleCondition = leftSide <= rightSide || visibleCondition;
                    }
                    break;
                default:
                    if (visibilityType === "all") {
                        visibleCondition = false;
                    }
                    break;

            }
        } else if (condition.AccessRole) {
            switch (condition.Operator) {
                case "equal":
                    if (visibilityType === "all") {
                        visibleCondition = visibleCondition && accessRoles.includes(condition.AccessRole);
                    } else {
                        visibleCondition = accessRoles.includes(condition.AccessRole) || visibleCondition;
                    }
                    break;
                case "notEqual":
                    if (visibilityType === "all") {
                        visibleCondition = visibleCondition && !accessRoles.includes(condition.AccessRole);
                    } else {
                        visibleCondition = !accessRoles.includes(condition.AccessRole) || visibleCondition;
                    }
                    break;
                default:
                    if (visibilityType === "all") {
                        visibleCondition = false;
                    }
                    break;

            }
        }
        if (visibilityType === "any" && visibleCondition) {
            break;
        }
    }
    return visibleCondition;
}
